import React from 'react'
import Quiz from './Quiz'
import Endtest from './Endtest'

export const types = {
  quiz: Quiz,
  endtest: Endtest,
}

export const IntroType = props => {
  const Component = types[props.type]
  return <Component {...props} />
}
